// TODO: refactor this file into smaller styled-components wrappers

﻿import styled from 'styled-components';
import hexToRgba from 'hex-to-rgba';
import definitions from '../../Style/LfStyleDefinitions';
import { iconCode, mediaQuery, clearFix } from '../../Style/cssHelpers';

const propsToExclude = ['paddingTop', 'displayValue', 'noBorder', 'alternateBackground', 'noTopPadding', 'noSidePadding', 'transparentBackground', 'rightAlign'];


export const DynamicFormErrorWrapper = styled.div`
    display: inline-block;
    width: 100%;
    text-align: right;

    span {
        display: block;

        color: ${definitions.colors.error};
        font-weight: 400;
        font-size: 16px;
        margin-top: 10px;

        ${mediaQuery.small(`
            font-size: 13px;
        `)}
    }
`;

export const DynamicFormCustomForm = styled.form`
    background-color: ${definitions.colors.blueBackground};
`;

export const QuestionGroup = styled.div`
    background-color: #fff;
    border-radius: 5px;

    padding: 37px;
    ${mediaQuery.small(`
        padding: 0px;
    `)}

    &:not(:first-of-type){
        margin-top: 40px;
        ${mediaQuery.small(`
            margin-top: 20px;
        `)}
    }
`;

export const SubQuestionGroup = styled(QuestionGroup)`
    padding: 0px;
`;

export const InformationBox = styled(QuestionGroup)`
    background-color: ${definitions.colors.blueBackground};
    border-radius: 5px;
    clear: both;
    color: #fff;
    line-height: 1.4;
    margin: 10px auto 50px auto;
    padding: 30px 35px;
    position: relative;

    ${clearFix()};

    ${mediaQuery.medium(`
        padding: 20px 25px;
    `)}

    ${mediaQuery.small(`
        padding: 17px;
        margin: 0px auto 17px auto;
    `)}

    .memberInfoContainer,
    .nextStepBtn,
    .saveForLaterBtn,
    .sendConfirmedAnswersBtn {
        display: inline-block;
    }

    .memberInfoContainer {
        display: block;
        float: left;

        ${mediaQuery.small(`
            display: block;
        `)}

        h3 {
            font-family: ${definitions.fonts.main};
            ${mediaQuery.small(`
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                padding-bottom: 17px;
            `)}
        }

        p, h3 {
            font-size: 16px;
            margin: 0px auto;
            ${mediaQuery.xxsmall(`
                font-size: 13px;
            `)}
        }

        .memberInfoName, h3 {
            font-size: 18px;
            ${mediaQuery.xxsmall(`
                font-size: 16px;
            `)}
        }

        .memberInfoName {
            margin: 10px auto;
        }

        .memberInfoZipCodeArea {
            margin-bottom: 17px;
        }

        span {
            font-weight: bold;
            margin-right: 5px;
        }
    }

    .informationBoxBtnContainer {
        text-aling: right;
        position: absolute;
        bottom: 30px;
        right: 40px;

        ${mediaQuery.small(`
            float:  none;
            position: initial;
            text-align: center;
            margin-top: 30px;
            width: 100%;
        `)}

        ${mediaQuery.medium(`
            float: left;
            bottom: 20px;
            right: 20px;
        `)}

        ${mediaQuery.large(`
            bottom: 30px;
            right: 40px;
        `)}
    }

    .nextStepBtn,
    .sendConfirmedAnswersBtn {
        ${mediaQuery.small(`
            display: block;
            margin: 10px auto 0 auto;
        `)}

        padding: 10px 20px 10px 20px;

        font-family: ${definitions.fonts.main};
        font-size: 16px;
        font-weight: bold;
        color: white;

        background-color: ${definitions.colors.green};
        border-radius: 5px;
        margin-left: 30px;

        &:disabled {
            background-color: ${hexToRgba(definitions.colors.green, 0.5)};
            cursor: not-allowed;
        }

        ${mediaQuery.small(`
            padding: 10px 17px;
            line-height: 1;
        `)}

        ${mediaQuery.xxsmall(`
            font-size: 13px;
        `)}
    }

    .autoSavedDraftNotice {
        width: 100%;
        text-align: left;
        ${mediaQuery.small(`
            text-align: center;
        `)}

        span {
            display: inline-block;

            font-size: 14px;
            ${mediaQuery.small(`
                margin-top: 10px;
            `)}
        }
    }

    .nextStepBtn:after {
        color: white;
        padding-left: 10px;
        font-size: 14px;
        font-weight: normal;

        ${iconCode.arrowRight()}
        transition: transform 300ms ease-out;

        ${mediaQuery.small(`
            font-size: 9px;
            position: relative;
            top: -1px;
        `)}
    }

    .editBtn {
        background: none;
        color: white;
        border: none;
        padding: 0px;
        font: inherit;
        font-size: 16px;
        cursor: pointer;

        ${mediaQuery.small(`
            padding: 0px 15px;
        `)}

        ${mediaQuery.xxsmall(`
            font-size: 13px;
        `)}
    }
`;

export const DynamicFormHeading = styled.h4`
    font-family: ${definitions.fonts.main};
    font-size: 20px;

    font-weight: bold;
    margin-bottom: 20px;

    ${mediaQuery.small(`
        padding: 17px;
        margin-bottom: 0px;
    `)}

    ${mediaQuery.xxsmall(`
        font-size: 16px;
    `)}
`;

export const DynamicFormPreamble = styled.p`
    font-family: ${definitions.fonts.main};
    font-size: 16px;
    font-weight: bold;
    line-height: 1.2;
    margin-top: 0px;

    ${mediaQuery.small(`
        margin: 0px 17px 17px 17px;

        &:empty {
            margin: 0px;
        }
    `)}

    ${mediaQuery.xxsmall(`
        font-size: 13px;
    `)}
`;

export const Level1RowContainer = styled.div.withConfig({
    shoudlForwardProps: (prop) => !propsToExclude.includes(prop)
})`
    border: 1px solid ${definitions.colors.grayBorder};
    border-bottom: none;

    ${props => props.noTopMargin ? `
        border-top: none;
    `:''}

    margin: ${props => props.noTopMargin ? '0' : '20px'} auto 0px auto;

    width: 100%;
    &:first-of-type {
        margin: 0px auto;
    }
`;

const levelPropstoExclude = ['paddingTop', 'displayValue', 'noBorder', 'alternateBackground', 'noTopPadding', 'noSidePadding', 'transparentBackground', 'rightAlign'];

export const Level2RowContainerNoStripes = styled(Level1RowContainer).withConfig({
    shouldForwardProp: (prop) => !levelPropstoExclude.includes(prop)
})`
    padding: ${props => props.paddingTop ? props.paddingTop : '0px'} 30px;

    border: none;
    border-bottom: 1px solid ${definitions.colors.grayBorder};
    display: ${props => props.displayValue === 'block' ? 'block' : 'none'};
    margin: 0px auto;
    ${mediaQuery.small(`
        padding: 0px;
    `)}

    ${props => props.noBorder ? `
        border-bottom: 0px solid ${definitions.colors.grayBorder};
    `:''};
`;

const levelTwoRowContainerNoStripesPropsToExclude = ['alternateBackground'];
export const Level2RowContainer = styled(Level2RowContainerNoStripes)`
    background-color: ${definitions.colors.grayBackgroundDarker};

    ${props => props.alternateBackground ? `
        &:nth-child(odd) {
            background-color: ${definitions.colors.grayBackgroundDarkest} !important;
        }
    `:''};
`;


export const Level2RowButtonContainer = styled(Level2RowContainer).withConfig({
    shouldForwardProp: (prop) => !levelPropstoExclude.includes(prop)
})`
    display: block;
    padding-top: 10px !important;

    ${props => props.rightAlign ? `
        text-align: right;
    `:''}
    ${props => props.noSidePadding ? `
        padding-left: 0px;
        padding-right: 0px;
    `:''}
    ${props => props.noTopPadding ? `
        padding-top: 0px !important;
    `:''}
    ${props => props.transparentBackground ? `
        background-color: transparent !important;
    `:''}
`;

const repeatGroupButtonPropsToExclude = ['inlineBlock'];

export const RepeatGroupButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !repeatGroupButtonPropsToExclude.includes(prop)
})`
    width: auto;
    margin: 0 auto;
    display: block;

    margin-top: 20px;
    margin-bottom: 30px;

    padding: 10px 50px 10px 50px;

    font-size: 16px;
    font-family: ${definitions.fonts.main};


    ${props => props.inlineBlock ? `
        display: inline-block;
    `:''}

    ${mediaQuery.small(`
        font-size: 14px;
        padding: 10px 30px 10px 30px;
    `)}

    ${mediaQuery.small(`
        font-size: 14px;
        padding: 10px 30px 10px 30px;
        max-width: 70vw;
    `)}

    ${mediaQuery.xxsmall(`
        font-size: 12px;
        padding: 10px;
        font-size: 12px;
        max-width: 70vw;
    `)}
`;

export const GroupRepetitionButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !levelPropstoExclude.includes(prop)
})`
    width: auto;
    display: inline-block;
    position: relative;

    margin: 17px 0px;

    padding: 0px;

    background: transparent;

    font-family: ${definitions.fonts.main};
    color: #182329;	
    font-size: 14px;	
    line-height: 17px;

    padding-right: 21px;

    font-weight: normal;


    &:after {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        ${iconCode.plus()}
        border-radius: 50%;
        color: #fff;
        background: red;
        transform-origin: center;
        background: ${definitions.colors.green};
    
        margin-top: -1px;

        width: 15px;
        height: 15px;
        font-size: 11px;
        line-height: 15px;
        padding-left: 1px;
        text-align: center;

        ${props => props.removeIcon ? `
            background: ${definitions.colors.error};
            transform: translate(0, -50%) rotate(-45deg);
            font-size: 12px;
            padding-top: 1px;
            padding-left: 0px;
        `:''}

        display: flex;
        justify-content: center;
        align-items: center;
    }



    ${mediaQuery.small(`
        max-width: 70vw;
        margin: 17px 17px;
    `)}

    ${mediaQuery.xxsmall(`
        font-size: 12px;
        font-size: 12px;
        max-width: 70vw;
        margin: 17px 17px;

    `)}
`;

export const Level3RowContainer = styled(Level2RowContainer)`
    background-color: #fff;
    border: 1px solid ${definitions.colors.grayBorder};
    margin: 0px auto 17px auto;
    top: 14px;
    position: relative;
    &:first-of-type {
        margin: 0px auto 17px auto;
    }
`;


const formRowPropsToExclude = ['styleForConfirmView', 'paddingTop', 'displayValue', 'noBorder', 'alternateBackground', 'noTopPadding', 'noSidePadding', 'transparentBackground', 'rightAlign'];
export const DynamicFormRow = styled.div.withConfig({
    shouldForwardProp: (prop) => !formRowPropsToExclude.includes(prop)
})`
    padding: 15px 30px;

    ${mediaQuery.small(`
        padding: 15px 17px;
        word-wrap: break-word;
    `)}

    background-color: transparent !important;
    border-bottom: 1px solid ${definitions.colors.grayBorder};
    font-weight: bold;
    overflow: ${props => props.styleForConfirmView ? 'auto' : 'initial'};
    width: 100%;

    ${clearFix()}

    label, legend, .dynamicFormConfirmedQuestion, .dynamicFormConfirmedAnswer {
        box-sizing: border-box;
        margin: 0;
        width: 40%;
        font-family: ${definitions.fonts.heading};
        font-size: 16px;
        font-weight: bold;
        line-height: 1.2;

        ${mediaQuery.small(`
            padding-right: 10px;
            width: 60%;
        `)}

        ${mediaQuery.xxsmall(`
            font-size: 13px;
        `)}
    }

    .dynamicFormSubmittedAnswerContainer {
        line-height: 1.2;
    }

    .dynamicFormConfirmedQuestion, .dynamicFormConfirmedAnswer {
        display: inline-block;
        padding: 5px 0px;
        width: auto;
    }

    .dynamicFormConfirmedQuestion {
        margin-right: 10px;
        max-width: 60%;
        ${mediaQuery.xxsmall(`
            max-width: 50%;
        `)}
    }

    .dynamicFormConfirmedAnswer {
        float: right;
        font-family: ${definitions.fonts.main};
        text-align: right;
        max-width: 60%;
        ${mediaQuery.small(`
            max-width: 100%;
        `)}
    }

    label {
        display: inline-block;
        padding: 7px 10px 7px 0px;

        ${mediaQuery.small(`
            display: block;
            padding-top: 0px;
            width: 100%;
        `)}
    }

    .textareaLabel {
        float: left;
    }

    fieldset {
        display: block;
        border: 0;
        padding: 5px 0px;
        ${mediaQuery.xxsmall(`
            padding: 0px;
        `)}
        margin: 0;
        width: 100%;

        ${clearFix()}

        legend {
            float: left;
            padding-top: 4px;
            display: inline-block;

            ${mediaQuery.small(`
                float: none;

                margin: 2px 0px;
                padding-top: 0px;
                width: calc(100% - 120px);
            `)}

            ${mediaQuery.xxsmall(`
                margin: 4px 0px;
            `)}
        }

        .dynamicFormRadioContainer {
            position: relative;
            width: 60%;
            display: block;
            float: right;

            text-align: right;

            ${mediaQuery.small(`
                width: 100%;
                float: none;
                text-align: left;
            `)}

            ${mediaQuery.xxsmall(`
                text-align: left;
            `)}

            ${clearFix()}

            label {
                width: auto;
                display: inline-block;

                font-family: ${definitions.fonts.heading};
                font-weight: normal;

                &:not(:last-of-type) {
                    padding-right: 35px;
                    ${mediaQuery.small(`
                        padding-right: 30px;
                    `)}

                    ${mediaQuery.xxsmall(`
                        padding-right: 20px;
                    `)}
                }
            }

            [type="radio"]:checked,
            [type="radio"]:not(:checked) {
                position: absolute;
                left: -9999px;
            }

            [type="radio"]:checked + label,
            [type="radio"]:not(:checked) + label {
                position: relative;
                padding-left: 28px;
                cursor: pointer;
                line-height: 20px;
                display: inline-block;
            }

            [type="radio"]:checked + label:before,
            [type="radio"]:not(:checked) + label:before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);

                ${mediaQuery.small(`
                    transform: translateY(-75%);
                `)}

                width: 20px;
                height: 20px;

                border: 1px solid ${definitions.colors.grayBorder};
                border-radius: 100%;
                background: ${definitions.colors.grayBackground};
            }

            [type="radio"]:checked + label:after,
            [type="radio"]:not(:checked) + label:after {
                position: absolute;

                content: '';
                width: 10px;
                height: 10px;

                background: ${definitions.colors.green};

                top: 12px;
                left: 5px;

                ${mediaQuery.small(`
                    top: 4px;
                `)}

                border-radius: 100%;

                transition: all 0.2s ease;
            }

            [type="radio"]:not(:checked) + label:after {
                opacity: 0;
                transform: scale(0);
            }

            [type="radio"]:checked + label:after {
                opacity: 1;
                transform: scale(1);
            }
        }
    }

    body:not(:-moz-handler-blocked) fieldset {
        display: table-cell;
    }

    input[type=text], input[type=email], input[role="combobox"], textarea {
        width: 50%;
        padding: 7px;
        line-height: 1;
        float: right;
        -webkit-appearance: none;

        background-color: ${definitions.colors.grayBackground};
        border: 1px solid ${definitions.colors.grayBorder};

        font-family: ${definitions.fonts.heading};
        font-weight: normal;

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }

        ${mediaQuery.small(`
            float: none;
            display: block;
            padding: 5px;
            width: 100%;
        `)}

        ${mediaQuery.xxsmall(`
            font-size: 13px;
        `)}
    }

    textarea {
        float: right;
        -webkit-appearance: none;

        min-height: 160px;
        resize: none;
    }

    input[type=text]::placeholder, input[type=email]::placeholder {
        opacity: 0.3;
    }

    input[type=text].is-invalid-input, input[type=email].is-invalid-input {
        border: 1px solid ${definitions.colors.error};
    }

    textarea.is-invalid-input {
        background-color: ${definitions.colors.error};
    }

    &:last-of-type {
        border-bottom: none;
    }

    .dynamicFormCheckboxContainer {
        position: relative;
        ${mediaQuery.small(`
            label {
                display: inline-block;
                padding-top: 7px;
                width: calc(100% - 120px);
            }
        `)}

        .dynamicFormCheckboxFauxLabel {
            float: right;
            font-weight: normal;
            margin-top: 2px;
            margin-left: 10px;

            ${mediaQuery.xxsmall(`
                font-size: 13px;
            `)}
        }

        .dynamicFormCheckboxWrapper {
            position: relative;
            z-index: 1;
            float: right;
            margin-top: 7px;


            input[type="checkbox"],
            .dynamicFormCheckbox {
                width: 20px;
                height: 20px;
            }

            input[type="checkbox"] {
                position: absolute;
                right: 0;
                top:0;

                opacity: 0;
                margin: 0px;
                z-index: 2;
                width: 30px;
                height: 30px;
                cursor: pointer;
            }

            .dynamicFormCheckbox {
                display: block;
                min-width: 20px;
                min-height: 20px;
                content: '';
                cursor: pointer;
                background: ${definitions.colors.grayBackground};
                border: 1px solid #c5c9cc;
                border-radius: 4px;

                &:after {
                    position: relative;
                    opacity: 0;
	                ${iconCode.check()}
                    color: #00873F;
                    font-size: 11px;
                    font-weight: normal;
                    left: 3px;
                    top: -5px;
                }
            }

            input[type=checkbox]:checked ~ .dynamicFormCheckbox:after {
                opacity: 1;
            }

            .dynamicFormCheckboxFauxLabel {
                font-weight: normal;
                float: right;
            }
        }
    }

    .dynamicFormSelectContainer {
        select {
            min-width: 200px;
            width: 50%;
            float: right;

            padding: 7px;

            font-family: ${definitions.fonts.heading};
            font-weight: normal;

            border-radius:2px;
            background: ${definitions.colors.grayBackground};
            border: solid 1px ${definitions.colors.grayBorder};

            -webkit-appearance: none;
            -moz-appearance: none;
            cursor: pointer;

            background-image: url('/images/arrows.svg');
            background-position: right 0 bottom 6px;
            background-size: 20px 20px;
            background-repeat: no-repeat;

            font-size:16px;
            line-height:1.2;
            color: ${definitions.colors.grayText};

            &:disabled {
                cursor: not-allowed;
                opacity: 0.5;
            }

            ${mediaQuery.small(`
                background-position: bottom 6px right 0px;
                background-size: 15px 15px;

                width: 100%;

                padding: 5px;
            `)}

            ${mediaQuery.xxsmall(`
                background-position: bottom 6px right 0px;
                font-size: 13px;
            `)}
        }

        select.is-invalid-input {
            border: 1px solid ${definitions.colors.error};
            margin-bottom: 0px;
        }
    }

    .dynamicFormDateWrapper {
        ${clearFix()}

        .dynamicFormDateInputContainer {
            display: inline-block;
            width: 50%;
            ${mediaQuery.small(`
                width: 100%;
            `)}

            max-height: 34px;
            float: right;

            input {
                width: 100%;
            }
        }
    }

    .dynamicFormAutocompleteWrapper {
        position: relative;
        float: right;
        width: 50%;

        ${mediaQuery.small(`
            width: 100%;
        `)}


        & > div {
            display: inline-block;
            width: 100%;

            input {
                width: 100%;
                padding: 7px;
                line-height: 1;
                float: right;
                appearance: none;
                background-color: rgb(252, 252, 252);
                border: 1px solid rgb(219, 222, 224);
                font-family: "VAG Rounded", sans-serif;
                font-weight: normal;
            }

            .dynamicFormAutocompleteMenu {
                position: absolute;
                top: 37px;
                left: 0;

                width: 100%;
                max-height: 70vh;

                z-index: 99;

                ${mediaQuery.small(`
                    max-height: 200px;
                    overflow-y: scroll;
                `)}

                background-color: white;
                box-shadow: 0px 2px 22px -2px rgba(0,0,0,0.51);

                .dynamicFormAutocompleteMenuItem {
                    padding: 10px;
                    background: white;
                    color: black;
                    cursor: default;
                    font-weight: normal;

                    ${mediaQuery.small(`
                        width: 100%;
                        font-size: 13px;
                    `)}

                    &--active {
                        background: ${definitions.colors.green};
                        color: white;
                        cursor: pointer;
                    }
                }
            }
        }
    }
`;

export const DynamicFormLevel2Row = styled(DynamicFormRow)`
    padding: 17px 0px;
`;

export const DynamicFormLevel3Row = styled(DynamicFormLevel2Row)`
    background-color: #fff;
`;

export const DynamicFormHelpTextWrapper = styled.span`
    position: relative;
    font-weight: normal;
    .helpTextIcon {
        background: none;
        border: 0;
        box-sizing: content-box;
        cursor: pointer;
        color: ${definitions.colors.blueBackground};
        height: 1em;

        transition: all 3s ease-in-out;
        padding: 0px 7px;
        position: absolute;

        &:after {
            font-size: initial;
            font-weight: normal;
            ${iconCode.informationIcon()}
            position: relative;
            top: -5.5px;

            ${mediaQuery.small(`
                top: 1px;
            `)}

            ${mediaQuery.xxsmall(`
                font-size: 12px;
                top: -1px;
            `)}
        }

        &:hover {
            color: #23527c;
        }

        span {
            display: none;
        }
    }

    .helpText {
        display: ${props => props.helpTextVisibility === true ? 'block' : 'none'};
        position: absolute;
        top: 21px;
        left: -200px;
        padding-top: 5px;
        z-index: 1;

        ${mediaQuery.small(`
            position: relative;
            top: 15px;
            left: 0px;
            height: 0px;
            padding: 0px;
            width: 0px;
        `)}

        .helpTextArrow {
            display: block;
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            border-bottom: 11px solid ${definitions.colors.blueBackground};
            margin: 0px auto -1px auto;
            ${mediaQuery.small(`
                display: none;
            `)}
        }

        .helpTextContent {
            background-color: ${definitions.colors.blueBackground};
            color: #fff;
            display: block;
            text-align: left;
            border-radius: 10px;
            padding: 25px 30px;
            margin: 0px auto;
            width: 430px;
            line-height: 1.2;
            box-shadow: -1px 4px 10px -1px rgba(0,0,0,0.4);

            ${mediaQuery.small(`
                padding: 15px 20px;
                width: 80vw;
                position: absolute;
            `)}
        }
    }
`;
